var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_3662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4848 11.6638C19.8728 11.402 20.2756 11.162 20.6889 10.9624C20.0934 14.782 20.9066 18.6959 23.0707 21.9044C25.2348 25.1128 28.5591 27.3329 32.3237 28.2116C31.9837 28.5201 31.6103 28.8036 31.2223 29.0654C26.1887 32.4606 19.4574 31.32 16.2223 26.5237C12.9871 21.7274 14.4512 15.059 19.4848 11.6638ZM18.0176 9.48861C11.717 13.7384 9.89001 22.0599 13.9394 28.0635C17.9889 34.067 26.3889 35.4903 32.6895 31.2406C34.7668 29.8394 36.3518 27.979 37.4061 25.9229C32.7242 26.3433 28.0678 24.3887 25.3535 20.3646C22.6392 16.3405 22.5713 11.2909 24.715 7.10743C22.4135 7.31471 20.0949 8.08742 18.0176 9.48861Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_3662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.0428,
    height: 31.4851,
    fill: "white",
    transform: "translate(0 18.4766) rotate(-34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.13d2f43b4e50d141e40f0493d31a8241.svg";
export { ForwardRef as ReactComponent };